<template>
  <div>
    <div class="miss-word-text">
      <span
        v-for="(variant, key) in work.metadata.variants"
        :key="key"
        v-html="variant.value"
        :class="`${variant.type === 'answer' ? 'answer' : ''}`"
      ></span>
    </div>
    <span class="badge badge-danger">{{
      check ? "Правильно" : "Неправильно"
    }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["data", "work"],
  computed: {
    check() {
      let trueStatus = true;

      let decision = this.work.decisions;
      let variants = this.work.metadata.variants.filter((item) => {
        return item.type == "answer";
      });

      console.log(variants);

      for (let i = 0; i < decision.length; i++) {
        if (decision[i].answer != variants[i].value) {
          trueStatus = false;
        }
      }

      return trueStatus;
    },
  },
};
</script>

<stype lang="scss">
.miss-word-text {
  display: flex;
  flex-wrap: wrap;
  & > span {
  
    padding: 3px;
    line-height: 16px;
    font-size: 16px;
    &.answer {
      background: #ebebeb;
    }
  }
}
</stype>